<template>
    <el-dialog
        :visible="visible"
        :modal-append-to-body="true"
        class="ah-detail-dialog accounting-year-voucher-detail"
        top="10vh"
        width="400px"
        append-to-body
        :before-close="onBeforeClose"
        :lock-scroll="false"
        @open="onOpen"
    >
        <template slot="title">年度結算</template>

        <div class="detail-row">
            <template v-if="!isAddingTaxVoucher">
                <el-form ref="form" :model="form" :rules="rules">
                    <el-form-item prop="forwardYear" label-width="110px" label-position="left">
                        <template slot="label">
                            <span class="label">結算年度<ah-tip>該年度未開帳則不可結算</ah-tip></span>
                        </template>
                        <el-select v-model="form.forwardYear" style="width: 130px">
                            <el-option v-for="item in yearList" :key="item.year" :value="item.year" :label="item.label" :disabled="item.disabled" />
                        </el-select>
                    </el-form-item>
                </el-form>
                <el-button @click="onAddTaxVoucher">新增所得稅費用立帳傳票</el-button>
                <el-button @click="onForwardYear">年度結算</el-button>
            </template>
            <template v-else>
                <el-form ref="form" :model="form" :rules="rules">
                    <el-form-item prop="forwardYear" label-width="100px" label-position="left">
                        <template slot="label">
                            <span class="label">結算年度</span>
                        </template>
                        <el-select v-model="form.forwardYear" style="width: 130px">
                            <el-option v-for="item in yearList" :key="item.year" :value="item.year" :label="item.label" :disabled="item.disabled" />
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="taxAmt" label-width="100px" label-position="left">
                        <template slot="label">
                            <span class="label">所得稅金額</span>
                        </template>
                        <MoneyInput v-model="form.taxAmt" style="width: 150px" />
                    </el-form-item>
                </el-form>

                <el-button @click="onCancelAddTax">取消</el-button>
                <el-button type="primary" @click="onCreateTaxVoucher">建立</el-button>
            </template>
        </div>
    </el-dialog>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import ahTip from '@/components/ui/ahTip.vue';

export default {
    components: { ahTip },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        sno: {
            type: [Number, Object],
            default: null,
        },
    },
    computed: {
        forwardTWYear() {
            return this.form.forwardYear - 1911;
        },
    },
    data() {
        return {
            isAddingTaxVoucher: false,
            form: {
                forwardYear: null,
                taxAmt: 0,
            },
            rules: {
                forwardYear: [{ required: true, message: '請輸入結轉年度' }],
            },
            yearList: [],
        };
    },
    methods: {
        async onOpen() {
            const resp = await this.$api({
                url: 'AccountingSummaryReport/GetVoucherYears',
                method: 'GET',
            });

            const getLabel = ({
                year, hasInit, annualAccountingTaskStatus, annualAccountingTaskIsLocked,
            }) => {
                if (annualAccountingTaskStatus === 2) return `${year - 1911}（已關帳）`;
                if (annualAccountingTaskIsLocked) return `${year - 1911}（已鎖定）`;
                return `${year - 1911}${!hasInit ? '（未開帳）' : ''}`;
            };
            const isDisabled = ({ hasInit, annualAccountingTaskIsLocked }) => !hasInit || annualAccountingTaskIsLocked;

            this.yearList = resp.data.years.map((year) => ({
                ...year,
                label: getLabel(year),
                disabled: isDisabled(year),
            }));
        },
        onAddTaxVoucher() {
            this.isAddingTaxVoucher = true;
        },
        onCancelAddTax() {
            this.isAddingTaxVoucher = false;
            this.form.taxAmt = 0;
            this.form.forwardYear = null;

            this.$nextTick(() => {
                this.$refs.form.clearValidate();
            });
        },
        onBeforeClose() {
            this.$emit('close');
            this.onCancelAddTax();
        },
        onForwardYear() {
            this.$refs.form.validate(async (valid) => {
                if (!valid) return false;

                try {
                    const START_OF_QUERY_YEAR = moment()
                        .year(this.form.forwardYear)
                        .startOf('year')
                        .format('x');
                    const END_OF_QUERY_YEAR = moment()
                        .year(this.form.forwardYear)
                        .endOf('year')
                        .format('x');

                    const resp = await this.$api({
                        url: 'AccountingSummaryPage/QueryVouchers',
                        method: 'GET',
                        params: {
                            StartDateStart: START_OF_QUERY_YEAR,
                            StartDateEnd: END_OF_QUERY_YEAR,
                            TransactionType: 13,
                            PageSize: 25,
                            PageNum: 1,
                        },
                    });

                    const IS_FORWARDED = !!resp.data.items.length;
                    const CONFIRM_MSG = IS_FORWARDED ? `確定要再次結轉${this.forwardTWYear}年度嗎？（此動作將會覆蓋原本已開的結轉傳票）` : `確定要結轉${this.forwardTWYear}年度嗎？`;
                    await this.$confirm(CONFIRM_MSG, {
                        confirmButtonText: '確定',
                        cancelButtonText: '取消',
                    });
                    await this.$api({
                        url: '/AccountingSummaryPage/YearVoucher',
                        method: 'POST',
                        data: {
                            year: this.form.forwardYear,
                            settlementBelongDate: +moment().startOf('day').format('x'),
                        },
                    });
                    this.$emit('close', true);
                    this.onCancelAddTax();

                    return true;
                } catch (e) {
                    console.log(e);
                    return false;
                }
            });
        },

        async onCreateTaxVoucher() {
            this.$refs.form.validate(async (valid) => {
                if (!valid) return false;
                try {
                    await this.$confirm(`確定要建立${this.form.forwardYear}年度所得稅費用立帳傳票？（所得稅金額為 ${Number(this.form.taxAmt).toLocaleString('en')}）`, {
                        confirmButtonText: '確定',
                        cancelButtonText: '取消',
                    });

                    const DAT = Number(
                        moment()
                            .year(this.form.forwardYear)
                            .endOf('year')
                            .startOf('day')
                            .format('x'),
                    );

                    const accountingSettingsResp = await this.$api({
                        url: '/Tool/GetAccountingSettings',
                        method: 'GET',
                    });

                    const ACCOUNT_ITEMS = _.flatMap(accountingSettingsResp.data);

                    if (!ACCOUNT_ITEMS) {
                        this.$message({ showClose: true, message: '請先設定科目對應', type: 'error' });
                        return false;
                    }

                    const SUBMIT_DATA = {
                        accountItems: [
                            {
                                vocherSno: null,
                                vono: null,
                                accnO_SNO: ACCOUNT_ITEMS.find((o) => o.accno === '9013')?.sno,
                                content: '應繳營利事業所得稅',
                                crD_NTD: this.form.taxAmt,
                                deB_NTD: 0,
                                accno: '9013',
                            },
                            {
                                vocherSno: null,
                                vono: null,
                                accnO_SNO: ACCOUNT_ITEMS.find((o) => o.accno === '2163')?.sno,
                                content: '應繳營利事業所得稅',
                                crD_NTD: 0,
                                deB_NTD: this.form.taxAmt,
                                accno: '2163',
                            },
                        ],
                        dat: DAT,
                        cnl: false,
                        cny: 'TWD',
                        mem: null,
                        sno: null,
                        unT_NBR: '',
                        unt: null,
                        upD_USR: null,
                        vono: null,
                        voucherType: 11,
                        isEditing: false,
                    };
                    // 儲存變更
                    await this.$api({
                        url: '/AccountingSummaryPage/UpsertVouchers',
                        method: 'POST',
                        data: SUBMIT_DATA,
                    });

                    await this.checkIsCheckout();
                    this.$message({ showClose: true, message: '傳票已儲存', type: 'success' });
                    this.$emit('close', true);
                    this.onCancelAddTax();

                    return true;
                } catch (ex) {
                    if (ex === 'cancel') {
                        console.log(ex);
                        return false;
                    }
                    this.$message({ showClose: true, message: '傳票無法儲存', type: 'error' });
                    return false;
                }
            });
        },

        async checkIsCheckout() {
            const DAT = moment()
                .year(this.form.forwardYear)
                .endOf('year')
                .startOf('day');
            const YEAR = DAT.year() - 1911;

            // 檢查本年度是否提醒
            const NO_HINT_YEARS = JSON.parse(localStorage.getItem('voucher-no-hint-years')) || [];
            if (NO_HINT_YEARS.includes(YEAR)) return;

            // 檢查本年度是否已結算
            const resp = await this.$api({
                url: 'AccountingSummaryPage/QueryVouchers',
                method: 'GET',
                params: {
                    StartDateStart: DAT.startOf('year').format('x'),
                    StartDateEnd: DAT.endOf('year').format('x'),
                    TransactionType: 13,
                },
            });

            if (resp.data.totalNum > 0) {
                try {
                    await this.$confirm(`${YEAR}年度已結算，請重新結算本年度。`, '提醒', {
                        confirmButtonText: '我瞭解了，下次再提醒我',
                        cancelButtonText: '我瞭解了，本年度今天不再提醒',
                        type: 'warning',
                        center: true,
                    });
                } catch (e) {
                    localStorage.setItem('voucher-no-hint-day', moment().format('YYYY-MM-DD'));
                    NO_HINT_YEARS.push(YEAR);
                    localStorage.setItem('voucher-no-hint-years', JSON.stringify(_.uniq(NO_HINT_YEARS)));
                }
            }
        },
    },
};
</script>

<style lang="scss">
.accounting-year-voucher-detail {
    .year-display-block {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
    }
    .label {
        // margin-right: 10px;
        font-weight: bold;
    }
}
</style>
